module.exports = __webpack_public_path__ + "img/article-list-icon.7034658a.png";